import type { ICustomCategoriesWizardReactProps } from "app/components/customCategoriesWizard/custom-categories-wizard-react";
import { CustomCategoriesWizardReact } from "app/components/customCategoriesWizard/custom-categories-wizard-react";
import type * as React from "react";
import { BasicModal } from "@similarweb/ui-components";

import type { JSX } from "react";

interface ICustomCategoriesWizardProps {
    isOpen: boolean;
    onClose: VoidFunction;
    wizardProps: Omit<ICustomCategoriesWizardReactProps, "onClose">;
}

const modalStyles = {
    content: {
        padding: "0",
        width: "auto",
    },
};

export const CustomCategoriesWizard: React.FC<ICustomCategoriesWizardProps> = ({
    isOpen,
    onClose,
    wizardProps,
}): JSX.Element => {
    return (
        <BasicModal
            isOpen={isOpen}
            onRequestClose={onClose}
            closeIconConfig={{ show: false }}
            customStyles={modalStyles}
            shouldCloseOnOverlayClick={true}
        >
            <CustomCategoriesWizardReact
                {...wizardProps}
                onClose={onClose}
            />
        </BasicModal>
    );
};
// DO NOT USE NG-REACT with this component
